import { useState, useEffect } from "react";
import { Clock, TimerOff } from "lucide-react";
import { getLastActivity } from "@/lib/idleTracker";

export default function SessionInfo({ createdAt, timeoutMinutes, children }) {
  const [hover, setHover] = useState(false);
  const [remainingMin, setRemainingMin] = useState(null);

  useEffect(() => {
    if (!hover || !timeoutMinutes) return undefined;
    const compute = () => {
      const rem = timeoutMinutes * 60 * 1000 - (Date.now() - getLastActivity());
      setRemainingMin(Math.max(0, Math.ceil(rem / 60000)));
    };
    compute();
    const t = setInterval(compute, 1000);
    return () => clearInterval(t);
  }, [hover, timeoutMinutes]);

  const d = createdAt ? new Date(createdAt) : null;
  const isToday = d && d.toDateString() === new Date().toDateString();
  const time = d ? d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : null;
  const since = d
    ? (isToday ? time : `le ${d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" })} à ${time}`)
    : null;

  return (
    <div className="relative" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} data-testid="session-info-trigger">
      {children}
      {hover && (since || timeoutMinutes) && (
        <div className="absolute bottom-full left-0 mb-2 z-50 w-60 rounded-md bg-slate-800 border border-slate-600 shadow-xl px-3 py-2 space-y-1.5" data-testid="session-info-tooltip">
          {since && (
            <p className="text-[11px] text-slate-300 flex items-center gap-1.5" data-testid="session-connected-since">
              <Clock size={11} className="shrink-0" /> Connecté depuis {since}
            </p>
          )}
          {timeoutMinutes && remainingMin != null ? (
            <p className="text-[11px] text-slate-400 flex items-center gap-1.5" data-testid="session-remaining">
              <TimerOff size={11} className="shrink-0" /> Déconnexion auto dans {remainingMin} min
            </p>
          ) : null}
        </div>
      )}
    </div>
  );
}
